(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-fic-track]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-fic-item]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fic-dot]'));

    if (items.length < 2 || dots.length === 0) return;

    var isClickScrolling = false;
    var scrollTimeout;

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function closestItemIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;

      items.forEach(function (item, i) {
        var itemCenter = item.offsetLeft + item.offsetWidth / 2;
        var dist = Math.abs(itemCenter - trackCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });

      return closest;
    }

    track.addEventListener('scroll', function () {
      if (isClickScrolling) return;
      window.clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(function () {
        setActiveDot(closestItemIndex());
      }, 80);
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (isNaN(idx) || !items[idx]) return;

        isClickScrolling = true;
        var target = items[idx];
        track.scrollTo({
          left: target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2,
          behavior: 'smooth'
        });
        setActiveDot(idx);

        window.setTimeout(function () {
          isClickScrolling = false;
        }, 500);
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-fic-section]');
    sections.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSlider(event.target);
  });
})();